import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { getDaysOfWeekOptions, getDaysOfWeekLabels } from 'utils/helpers';
import { ControlledField, SelectInputField } from 'remote/global';

interface Props {
  formInstance: UseFormReturn<any>;
  name: string;
  translationKey?: string;
}
function DaysOfWeekPickerField(props: Props) {
  const { formInstance, name, ...rest } = props;
  const tInstance = useTranslation();
  const { control } = formInstance;

  return (
    <ControlledField
      control={control}
      name={name}
      render={(renderProps) => (
        <SelectInputField
          {...renderProps}
          {...rest}
          options={getDaysOfWeekOptions(tInstance)}
          fieldProps={{
            multiple: true,
            renderValue: (value) => getDaysOfWeekLabels(value, tInstance),
          }}
        />
      )}
    />
  );
}

export default DaysOfWeekPickerField;
